angular
  .module('contrast.settings.profile', [])
  .controller(
    'ProfileCtrl',
    function (
      $scope,
      $rootScope,
      $q,
      logger,
      UserFactory,
      ProfileFactory,
      GlobalFactory,
      avatarFactory,
      ErrorService,
      ProfileService,
      I18N_LANGUAGES,
      $translate
    ) {
      'ngInject'

      function init() {
        $scope.loadingPromise = $q.all([getProfile(), getTimeFormats()])
      }

      angular.extend($scope, {
        profile: {},
        model: {
          date_formats: [],
          time_formats: [],
          timezones: [],
          languages: [],
          saving: false
        },
        avatarUrl: false,
        gravatar: false,
        avatar: undefined,
        loadingPromise: null
      })

      angular.extend($scope, {
        save: save
      })

      function getAvatar(username) {
        return avatarFactory.getAvatarUrl(username).then(function (urlInfo) {
          $scope.avatarUrl = urlInfo.url
          $scope.gravatar = urlInfo.gravatar
          if (urlInfo.avatar) {
            $scope.avatarUrl = urlInfo.avatar
          }
        })
      }

      function getProfile() {
        return UserFactory.getOrganizationUserProfile(
          'preferences,group,beta_languages'
        ).then(function (response) {
          $scope.profile = ProfileService.buildProfile(response.data.user)
          setAvailableLanguages(false)
          return getAvatar($scope.profile.uid)
        }, ErrorService.processError)
      }

      function setAvailableLanguages(betaLanguagesEnabled) {
        var translatedLanguages = I18N_LANGUAGES.map(function (language) {
          return {
            value: language.value,
            text: $translate.instant(language.translationId),
            translationId: language.translationId,
            isBeta: language.isBeta
          }
        })
        if (betaLanguagesEnabled) {
          $scope.model.languages = translatedLanguages
        } else {
          $scope.model.languages = translatedLanguages.filter(function (
            language
          ) {
            return !language.isBeta
          })
        }
      }

      function getTimeFormats() {
        return $q
          .all({
            dateFormats: GlobalFactory.getDateFormats(),
            timeFormats: GlobalFactory.getTimeFormats(),
            timeZones: GlobalFactory.getTimeZones()
          })
          .then(function (response) {
            $scope.model.date_formats = response.dateFormats.data.date_formats
            $scope.model.time_formats = response.timeFormats.data.time_formats
            $scope.model.timezones = response.timeZones.data.timezones
          })
          .catch(ErrorService.processError)
      }

      function save() {
        $scope.model.saving = true

        var promises = [saveProfile()]

        if ($scope.avatar) {
          promises.push(saveAvatar())
        }

        return $q.all(promises).finally(function () {
          $scope.model.saving = false
        })
      }

      function saveProfile() {
        return ProfileFactory.saveProfile($scope.profile).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $rootScope.$broadcast('profile:updated', true)
            $scope.form.$dirty = false
          },
          function (response) {
            ErrorService.processError(response)
            return $q.reject(response)
          }
        )
      }

      function saveAvatar() {
        return avatarFactory
          .uploadUserAvatar($scope.avatar)
          .catch(function (response) {
            logger.logError('Unable to upload avatar')
            return $q.reject(response)
          })
      }

      init()
    }
  )
